import type { RoomTypeConfig } from '@/types'

export const DEFAULT_ROOM_TYPES: RoomTypeConfig[] = [
  {
    type: 'start',
    label: 'Start',
    color: '#4A7FB5',
    darkColor: '#6C8EBF',
    textColor: '#ffffff',
    darkTextColor: '#e8f0f8',
    weight: 0,
    description: 'Entry point. Always placed first.',
    icon: '⚑',
    flavors: ['Entry Hall', 'Guard Post', 'Gatehouse', 'Foyer', 'Antechamber', 'Threshold'],
  },
  {
    type: 'boss',
    label: 'Boss',
    color: '#7A3B1E',
    darkColor: '#9B5030',
    textColor: '#ffffff',
    darkTextColor: '#f5ddd3',
    weight: 0,
    description: 'Final encounter. Always placed last.',
    icon: '☠',
    flavors: ['Throne Room', 'War Chamber', 'Lair', 'Sanctum', 'The Pit', 'Overlord\'s Hall', 'Final Gate'],
  },
  {
    type: 'treasure',
    label: 'Treasure',
    color: '#3A6B48',
    darkColor: '#4A7C59',
    textColor: '#ffffff',
    darkTextColor: '#d5ead9',
    weight: 12,
    description: 'Reward rooms. Low frequency.',
    icon: '◈',
    flavors: ['Vault', 'Armory', 'Hoard', 'Cache Room', 'Trophy Hall', 'Reliquary', 'Gold Cellar'],
  },
  {
    type: 'puzzle',
    label: 'Puzzle',
    color: '#5E3A8A',
    darkColor: '#7B5EA7',
    textColor: '#ffffff',
    darkTextColor: '#e5d8f5',
    weight: 15,
    description: 'Events, puzzles, lore rooms.',
    icon: '⬡',
    flavors: ['Glyph Room', 'Mirror Hall', 'Rune Chamber', 'Altar', 'Test of Will', 'Oracle\'s Den', 'Mechanism Room'],
  },
  {
    type: 'trap',
    label: 'Trap',
    color: '#8A4A1E',
    darkColor: '#A05A30',
    textColor: '#ffffff',
    darkTextColor: '#f5e0d0',
    weight: 10,
    description: 'Hazard rooms. Moderate frequency.',
    icon: '⚡',
    flavors: ['Spike Hall', 'Pressure Floor', 'Crusher Room', 'Pendulum Hall', 'Poison Mist Chamber', 'Fire Trench'],
  },
  {
    type: 'shop',
    label: 'Shop',
    color: '#5A6B3A',
    darkColor: '#6B7C4A',
    textColor: '#ffffff',
    darkTextColor: '#dde8d0',
    weight: 8,
    description: 'Merchant rooms. Rare.',
    icon: '⚖',
    flavors: ['Merchant\'s Corner', 'Black Market', 'Wanderer\'s Stall', 'Alchemist Nook', 'Curio Shop'],
  },
  {
    type: 'rest',
    label: 'Rest',
    color: '#3A5A6B',
    darkColor: '#4A6B7C',
    textColor: '#ffffff',
    darkTextColor: '#d0dde8',
    weight: 8,
    description: 'Safe zones. Rare.',
    icon: '⬘',
    flavors: ['Campsite', 'Hidden Alcove', 'Shrine of Rest', 'Old Barracks', 'Healer\'s Cell'],
  },
  {
    type: 'standard',
    label: 'Room',
    color: '#5A5650',
    darkColor: '#7A7670',
    textColor: '#ffffff',
    darkTextColor: '#e8e4df',
    weight: 47,
    description: 'Generic encounter rooms. Most common.',
    icon: '□',
    flavors: [
      'Barracks', 'Cistern', 'Gallery', 'Crypt', 'Larder', 'Shrine', 'Storage',
      'Passage', 'Cell Block', 'Watch Room', 'Kennels', 'Forge', 'Library',
      'Kitchen', 'Dungeon Cell', 'Ritual Chamber', 'Ossuary', 'Flooded Room',
    ],
  },
]

export const DEFAULT_CONFIG = {
  minRooms: 6,
  maxRooms: 14,
  extraLoopChance: 0.45,
  secretDoorChance: 0.12,
  lockedDoorChance: 0.1,
  onewayChance: 0.06,
  roomTypes: DEFAULT_ROOM_TYPES,
}
